import React, {useEffect, useState} from 'react';
import {Calendar, Avatar} from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import axios from 'axios';
import is from 'antd/locale/is_IS';

// Extend Window interface
declare global {
    interface Window {
        uuid: string;
    }
}

type Session = {
    id: number;
    uuid: string;
    date: string;
    event?: {
        category?: {
            icon?: string;
        };
    };
};

type Props = {
    url: string;
    onLoaded: () => void;
    onSelect: (sessions: Session[], moment_date: moment.Moment) => void;
    dateCellRender: (sessions: Session[], moment_date: moment.Moment) => React.ReactNode;
    className: string;
};

export default function EventCalendar({url, onLoaded, onSelect, dateCellRender, className}: Props) {
    const [sessions, setSessions] = useState<Session[]>([]);
    const [calendarSelectedDate, setCalendarSelectedDate] = useState(moment());

    useEffect(() => {
        updateCalendar(moment());
    }, []);

    const updateCalendar = (new_moment: moment.Moment) => {
        const m = new_moment ? new_moment : moment();
        if (url) {
            const start_date = moment(m).startOf('month').startOf('isoWeek');
            const end_date = moment(m).endOf('month').endOf('isoWeek').add(1, 'week');

            axios.get(url + '&date__gte=' + start_date.toISOString() + '&date__lte=' + end_date.toISOString()).then((rsp) => {
                setSessions(rsp.data.results);
                setCalendarSelectedDate(moment(m));

                onLoaded && onLoaded();
            });
        } else {
            onLoaded && onLoaded();
        }
    };

    const onCalendarChange = (new_moment: moment.Moment) => {
        if (!new_moment.isSame(calendarSelectedDate, 'month')) {
            updateCalendar(new_moment);
        }
    };

    return (
        <>
            <Calendar
                className={className}
                locale={is.DatePicker}
                onChange={(dayjsDate) => {
                    onCalendarChange(moment(dayjsDate.toDate()));
                }}
                onSelect={(dayjsDate) => {
                    if (onSelect) {
                        return onSelect(sessions, moment(dayjsDate.toDate()));
                    }

                    const found = sessions.filter((session) => moment(session.date).isSame(moment(dayjsDate.toDate()), 'day'));
                    if (found.length === 1 && window.top) window.top.location.href = '/timi/' + found[0].uuid + '/';
                }}
                cellRender={(dayjsDate) => {
                    if (dateCellRender) {
                        return dateCellRender(sessions, moment(dayjsDate.toDate()));
                    }

                    return (
                        <>
                            {sessions
                                ?.filter((session) => moment(session.date).isSame(moment(dayjsDate.toDate()), 'day'))
                                .map((sess) => {
                                    return (
                                        <a key={sess.id} href={'/timi/' + sess.uuid + '/'}>
                                            <Avatar size='small' src={sess.event?.category?.icon}></Avatar>
                                        </a>
                                    );
                                })}
                        </>
                    );
                }}
            ></Calendar>
        </>
    );
}
